import { render } from "./AccountMembers.vue?vue&type=template&id=51c28f54&ts=true"
import script from "./AccountMembers.vue?vue&type=script&lang=ts"
export * from "./AccountMembers.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__